module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.ttf?28806940c647cf671bebf4ae0630e570";